<template>
    <div class="layout-footer">
      <div class="footer-container">
        <div class="footer-item">
          <div class="contact">
            <h3>联系我们</h3>
            <div class="ewm-item">
              <img src="../../../assets/images/home/kf.png"/>
              <p>扫码联系客服</p>
            </div> 
            <div class="ewm-item">
              <img src="../../../assets/images/home/gzh_code.jpg"/>
              <p>关注象刀设计</p>
            </div>           
          </div>
          <div class="cooperation">
            <h3>合作</h3>
            <p>交换友情链接，业务合作请加QQ：310603354</p>
            <div class="links"><a v-for="(item, ind) in friendList" :key="ind" target="_blank" :href="item.url">{{item.name}}</a></div>
          </div>
        </div>
        <div class="footer-item">
          <div class="website">
            <h3>公司</h3>
            <a href="https://ppt.101dao.com/user_service/?type=1&f=design" target="_blank">关于我们</a>
          </div>
          <div class="website">
            <h3>声明</h3>
            <a href="https://ppt.101dao.com/user_service/?type=2&f=design" target="_blank">版权声明</a><a href="https://ppt.101dao.com/user_service/?type=2&f=design" target="_blank">注册协议</a><a href="https://ppt.101dao.com/user_service/?type=2&f=design" target="_blank">隐私政策</a><a href="https://ppt.101dao.com/custom/" target="_blank">定制服务</a>
          </div>
         <div class="website">
            <h3>资源</h3>
            <a href="/templates">模板</a><a href="https://sucai.101dao.com/sucai/miankou" target="_blank">素材</a><a href="https://sucai.101dao.com/sucai/background" target="_blank">图片</a><a href="https://sucai.101dao.com/sucai/music/" target="_blank">音频</a>
          </div>
        </div>
      </div>
      <div class="bottom_info">
        <div class="margin_center">
          <div class="beian_info">
            <span class="beianhao">Copyright © 2021 <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备2021105543号</a></span>
            <span class="company_name">广州极氪信息科技有限公司</span>
          </div>
          <div class="concat_info"><span class="">若您发现您的权利被侵害，请联系QQ：310603354</span></div>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { CommonService } from '@/api/common'
export default defineComponent({
  name: 'header',
  setup() {
    const friendList = ref([])
    const getFriendList = async () => {
      const params = {}
      const res = await CommonService.getFriendList(params)
      friendList.value = res.data.data
    }
    getFriendList()
    return {
      friendList
    }

  },
})
</script>

<style lang="scss" scoped>
.footer-container {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
  
  a:hover {
    color: $themeColor !important;
  }
  h3 {
    font-size: 16px;
    color: #39495e;
    margin-bottom: 20px;
  }
  .ewm-item {
    width: 104px;
    height: 104px;
    border: 1px solid #e6e8eb;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
    img {
      width: 100%;
      display: block;
    }
    p {
      color: #6f7a88;
      font-size: 12px;
      margin-top: 5px;
    }
  }
  .footer-item {
    display: flex;
    .contact {
      min-width: 400px;
    }
    .cooperation {
      p {
        color: #a4a7af;
      }
    }
    .links {
      a {
        color: #5f636d;
        line-height: 36px;
        margin-right: 10px;
      }
    }
    .website {
      margin-left: 60px;
      a {
        display: block;
        line-height: 36px;
        color: #a4a7af;
      }
    }
  }
}
.layout-footer .bottom_info {
    width: 100%;
    span, a {
      font-size: 12px;
      color: #a4a7af;
    }
}
.layout-footer .bottom_info .beian_info span {
    margin-right: 40px;
}
.layout-footer .bottom_info .margin_center {
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    color: rgb(164, 167, 175);
    font-size: 12px;
}
</style>